"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogService = void 0;
var tslib_1 = require("tslib");
var axios_1 = require("axios");
var get_auth_header_1 = require("@wix/wix-vod-shared/dist/src/common/utils/get-auth-header");
var hosts_1 = require("@wix/wix-vod-constants/dist/env/hosts");
var editor_type_1 = require("@wix/wix-vod-shared/dist/src/common/utils/editor-type");
var CatalogService = /** @class */ (function () {
    function CatalogService(baseUrlPath) {
        if (baseUrlPath === void 0) { baseUrlPath = ''; }
        var baseURL = editor_type_1.isEditorX()
            ? hosts_1.PRODUCTION_HOSTS.catalogEditorX
            : hosts_1.PRODUCTION_HOSTS.catalog;
        this.axiosInstance = axios_1.default.create({
            baseURL: baseURL + baseUrlPath,
            xsrfCookieName: 'non-existing-cookie',
            withCredentials: true,
        });
        this.axiosInstance.interceptors.request.use(function (req) {
            var headers = tslib_1.__assign(tslib_1.__assign({}, req.headers), get_auth_header_1.getAuthHeader());
            return tslib_1.__assign(tslib_1.__assign({}, req), { headers: headers });
        });
    }
    CatalogService.prototype.getAxiosInstance = function () {
        return this.axiosInstance;
    };
    return CatalogService;
}());
exports.CatalogService = CatalogService;
//# sourceMappingURL=catalog-service.js.map